import React from 'react';
import { Text, StyleSheet, TouchableWithoutFeedback, Platform, } from 'react-native';
import { theme } from '../theme';
const glyphMap = {
    arrow_drop_down: '\ue5c5',
    arrow_drop_up: '\ue5c7',
    assessment: '\ue85c',
    calendar_view_month: '\ue8ef',
    close: '\ue5cd',
    mic: '\ue029',
    notes: '\ue26c',
    person: '\ue7fd',
    visibility: '\ue8f4',
    visibility_off: '\ue8f5',
    photo_camera: '\ue412',
    zoom_out_map: '\ue56b',
    search: '\ue8b6',
    keyboard: '\ue312',
    trash: '\ue92e',
    trending_up: '\ue8e5',
};
/** iOS uses the font's PostScript name; Android/web match @font-face / asset name. */
const GLYPH_FONT_FAMILY = Platform.OS === 'ios' ? 'AbbisWayIcons-Regular' : 'AbbisWayIcons';
export const Glyph = ({ name, size = 24, color = theme.colors.textPrimary, style, onPress, disabled = false, }) => {
    const glyph = glyphMap[name];
    if (!glyph) {
        console.warn(`Glyph "${name}" does not exist in the glyph map.`);
        return null;
    }
    const combinedStyle = {
        fontSize: size,
        color: disabled ? theme.colors.controlInactive : color,
        ...style,
    };
    if (onPress) {
        return (<TouchableWithoutFeedback onPress={!disabled ? onPress : undefined}>
        <Text style={[styles.icon, combinedStyle]}>{glyph}</Text>
      </TouchableWithoutFeedback>);
    }
    return <Text style={[styles.icon, combinedStyle]}>{glyph}</Text>;
};
const styles = StyleSheet.create({
    icon: {
        fontFamily: GLYPH_FONT_FAMILY,
    },
});
